import z from "zod";

import { RADII, SIZES } from "@frontend/styles/constants";

import { PAGINATION_ALIGNS, PAGINATION_VARIANTS } from "./constants";

export const paginationDataSchema = z.object({
  page: z.coerce.number().default(1),
  pageCount: z.coerce.number().default(1),
  siblingCount: z.coerce.number().optional(),
  boundaryCount: z.coerce.number().optional(),
  size: z.enum(SIZES).optional(),
  variant: z.enum(PAGINATION_VARIANTS).optional(),
  radius: z.enum(RADII).optional(),
  align: z.enum(PAGINATION_ALIGNS).optional(),
  totalItems: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  summary: z.string().optional(),
  jump: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type PaginationDataProps = z.infer<typeof paginationDataSchema>;
